// utils/api.js
const BASE_URL = "https://tagprotect.in/api/service2"; // Base URL

export const handleTransferApi = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send4`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};

export const handleTransferApi15to16 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send15`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi25to16 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send25to16`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi15to17 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send15to17`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi15to18 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send15to18`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi16to19 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send16to19`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi16to20 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send16to20`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi17to21 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send17to21`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi17to22 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send17to22`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi18to23 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send18to23`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi18to24 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send18to24`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const fetchCount = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/tags/count-debit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ part1Value: '1B15B16' }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data.count;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const fetchTimeTaken = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/tags/calculate-time-difference`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data.timeDifferenceInMinutes;
  } catch (error) {
    console.error('Error fetching Time Taken:', error);
    throw error;
  }
};


// Function to handle panic button click
export const handlePanicButtonClickApi = async (part1Value, tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25) => {
  try {
    const response = await fetch(`${BASE_URL}/api/tags/mark-fraud`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ part1: part1Value }),
    });

    if (response.ok) {
      const data = await response.json();
      // Check all tag values against the part1Value and set the appropriate panic message
      if ([tag16, tag17, tag18, tag19, tag20, tag21, tag22, tag23, tag24, tag25].includes(part1Value)) {
        return data.message;
      }
    } else {
      console.error("Error marking fraud");
    }
  } catch (error) {
    console.error("Error occurred while calling API:", error);
  }
  return null;
};

// Function to handle truncate operation
export const handleTruncateApi = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/maintenance/truncateAll`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    return result.status;
  } catch (error) {
    console.error("Error during truncate operation:", error);
  }
  return null;
};

// Function to handle insert operation
export const handleInsertApi = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/insert-data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    return result.status1;
  } catch (error) {
    console.error("Error during insert operation:", error);
  }
  return null;
};
// Function to mark fraud with a specific part1 value
export const markFraud = async (part1Value) => {
  try {
    const response = await fetch(`${BASE_URL}/api/tags/mark-fraud`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ part1: part1Value }),
    });

    if (response.ok) {
      const data = await response.json();
      return data; // Return the API response data
    } else {
      console.error("Error marking fraud");
      return null;
    }
  } catch (error) {
    console.error("Error occurred while calling API:", error);
    return null;
  }
};
export const handleReleaseButton = async (input) => {
  try {
    console.log("api called");
    // Construct the API URL with the input as a query parameter
    const apiUrl = `${BASE_URL}/api/transactions/update-connected-tags?input=${encodeURIComponent(
      input
    )}`;

    // Make the PUT request (still using PUT method even though it's a query param)
    const response = await fetch(apiUrl, {
      method: "PUT", // Use PUT method
      headers: {
        "Content-Type": "application/json", // Content type header for consistency, though not strictly needed with query params
      },
    });

    // Check if the response is OK (status 200)
    if (!response.ok) {
      throw new Error("Failed to update connected tags");
    }

    // Parse the JSON response
    const result = await response.json();

    // Return the result (you can adjust this based on the actual structure of your response)
    return result; // or `result.status` or other fields depending on your API response
  } catch (error) {
    console.error("Error during release operation:", error);
    return null;
  }
};

//bank26to27
export const fetchFromAccounts26 = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/account-holders26`);
    if (!response.ok) {
      throw new Error("Error fetching from accounts.");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching from accounts:", error);
    throw error;
  }
};

export const fetchToAccounts27 = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/beneficiaries/all26`);
    if (!response.ok) {
      throw new Error("Error fetching to accounts.");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching to accounts:", error);
    throw error;
  }
};

export const fetchBank27Accounts = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/account-holders27/all`);
    if (!response.ok) {
      throw new Error("Error fetching Bank 27 account details.");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching Bank 27 account details:", error);
    throw error;
  }
};

// Function to submit a transaction
export const submitTransaction26 = async (formData, getCleanedAmount, setResponseMessage, setTransferredAmount, setTransactionDetails, setBox1Data, setBox2Data, setTransactionSubmitted, setReferenceNumber) => {
  try {
    const payload = {
      remitterAccountNumber: formData.fromAccount,
      beneficiaryAccountNumber: formData.toAccount,
      transactionMode: formData.transactionMode,
      amount: getCleanedAmount(),
      transactionId: formData.transactionId,
    };

    const response = await fetch(`${BASE_URL}/api/transactions/sendto27`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (data.error) {
      setResponseMessage('Transaction failed: ' + data.error);
      setTransactionDetails({
        accountNumber: formData.toAccount,
        availableBalance: data.availableBalance || '',
      });
    } else {
      setResponseMessage(data.message);
      setTransferredAmount(data.amountTransferred);
      setReferenceNumber(data.transactionId); // Use the response data to set reference number
      setTransactionDetails({
        accountNumber: data.accountNumber,
        availableBalance: data.availableBalance,
      });

      // Set the response data for box1 and box2
      setBox1Data({
        tag26: data.tag26,
        account26: data.account26,
        amountTransferred26: data.amountTransferred26,
        tagType26: data.tagType26,
        tagValidity26: data.tagValidity26,
      });

      setBox2Data({
        tag27: data.tag27,
        account27: data.account27,
        amountTransferred27: data.amountTransferred27,
        tagType27: data.tagType27,
        tagValidity27: data.tagValidity27,
      });
      setTransactionSubmitted(true); // Set form as submitted
    }
  } catch (error) {
    console.error('Error sending transaction:', error);
    setResponseMessage('Transaction failed');
  }
};

// Check Fraud Status
export const checkFraudStatus = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/transactions/checkFraud`);
    if (!response.ok) {
      throw new Error("Error checking fraud status.");
    }
    const data = await response.json();
    return data; // { "message": "Fraudulent Alert" } or { "message": "Account is not fraudulent" }
  } catch (error) {
    console.error("Error checking fraud status:", error);
    throw error;
  }
};


